import { render, staticRenderFns } from "./yhzx_table.vue?vue&type=template&id=46689adc&scoped=true"
import script from "./yhzx_table.vue?vue&type=script&lang=js"
export * from "./yhzx_table.vue?vue&type=script&lang=js"
import style0 from "./yhzx_table.vue?vue&type=style&index=0&id=46689adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46689adc",
  null
  
)

export default component.exports